import { START_TIMER, RESET_TIMER, CLOSE_POPUP, DECREMENT_TIMER } from '../actions/actionTypes'

const initialState = {
    timeStarted: false,
    showIdentityProofPopup: false,
    timeLeft: 30 * 60 * 1000, // 30 min in milliseconds
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case START_TIMER:
            return {
                ...state,
                timeStarted: true
            }
        case CLOSE_POPUP:
            return {
                ...state,
                showIdentityProofPopup: false
            }
        case DECREMENT_TIMER:
            const timeLeft = state.timeLeft - action.payload
            if (timeLeft <= 0) {
                return {
                    ...state,
                    timeLeft,
                    showIdentityProofPopup: true,
                    timeStarted: false
                }
            } else {
                return {
                    ...state,
                    timeLeft,
                }
            }
        case RESET_TIMER:
            return {
                ...state,
                timeStarted: false,
                showIdentityProofPopup: false,
                timeLeft: 30 * 60 * 1000,
            }
        default:
            return state;
    }
}

export default reducer;